<section class="slider__main-section" *ngIf="media$ | async; let mediaArray">
  <div class="slider__scroll-container" #scrollContainer>
    <div class="slider__scroll-content">
      <div *ngIf="!mediaArray?.length" class="slider__media-item-container">
        <img src="assets/img/image.svg" alt="no-image placeholder" />
      </div>
      <div
        #mediaElement
        class="slider__media-item-container"
        *ngFor="let mediaItem of mediaArray; let i = index"
      >
        <ng-container
          *ngIf="mediaItem.isProcessing || mediaItem.needsProcessing"
        >
          <p class="slider__media-item-container__processing">
            {{
              (mediaItem.isProcessing
                ? "certificateView.fileIsProcessing"
                : loginProcessMessage
                ? "certificateView.fileWillBeProcessedAfterLogin"
                : "certificateView.fileNeedsProcessing"
              ) | translate
            }}
          </p>
        </ng-container>
        <ng-container
          *ngIf="!(mediaItem.isProcessing || mediaItem.needsProcessing)"
        >
          <img
            #image
            loading="lazy"
            *ngIf="mediaItem.type === MediaType.Image"
            [src]="mediaItem.src"
            alt="Certificate image"
            (error)="image.src = 'assets/img/error.svg'"
          />
          <video
            #video
            *ngIf="mediaItem.type === MediaType.Video"
            [src]="mediaItem.src"
            [loop]="true"
            disablePictureInPicture
            [disableRemotePlayback]="true"
            [controlsList]="
              'nodownload noremoteplayback noplaybackrate nopictureinpicture'
            "
            (fullscreenchange)="onFullScreen($event)"
            [autoplay]="videoActive"
            (play)="cd.detectChanges()"
            (pause)="cd.detectChanges()"
            (volumechange)="cd.detectChanges()"
            [muted]="videoMuted"
            (error)="video.src = 'assets/img/error.svg'"
          ></video>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    class="slider__media-controls"
    *ngIf="(mediaArray?.length ?? 0) > 0"
    (touchstart)="swipeHandler($event, 'start')"
    (touchend)="swipeHandler($event, 'end')"
  >
    <div class="slider__media-controls__side-buttons-container">
      <span
        class="slider__media-controls__button slider__media-controls__button_video-icon"
        [class.slider__media-controls__button_active]="
          this.mediaArray?.[currentMediaIndex$.value]?.type === MediaType.Video &&
      !this.videoActive
        "
      ></span>
      <div
        class="slider__media-controls__side-button"
        *ngIf="(mediaArray?.length ?? 0) > 1"
        [class.slider__media-controls__side-button_left]="canScrollLeft"
        (click)="onPrevMedia()"
      ></div>
      <div
        class="slider__media-controls__central-area"
        [class.slider__media-controls__central-area_full-height]="
          (mediaArray?.length ?? 0) < 2
        "
        [class.slider__media-controls__central-area_clickable]="
          this.itemClickCB || this.videoCanBePlayed()
        "
        (click)="onCentralClick(currentMediaIndex$.value)"
        (dblclick)="goFullscreen(currentMediaIndex$.value)"
      ></div>
      <div
        class="slider__media-controls__side-button"
        *ngIf="(mediaArray?.length ?? 0) > 1"
        [class.slider__media-controls__side-button_right]="canScrollRight"
        (click)="onNextMedia()"
      ></div>
      <button
        class="slider__media-controls__button slider__media-controls__button_sound"
        [class.slider__media-controls__button_sound_muted]="videoMuted"
        [class.slider__media-controls__button_active]="videoCanBePlayed()"
        (click)="onSoundToggle(currentMediaIndex$.value)"
      ></button>
      <button
        class="slider__media-controls__button slider__media-controls__button_fullscreen"
        [class.slider__media-controls__button_active]="videoCanBePlayed()"
        (click)="goFullscreen(currentMediaIndex$.value)"
      ></button>
      <span
        class="slider__media-controls__fading-icon slider__media-controls__fading-icon_play"
        *ngIf="
          !getVideoElement(currentMediaIndex$.value)?.paused &&
          this.showPauseAnimations
        "
      ></span>
      <span
        class="slider__media-controls__fading-icon slider__media-controls__fading-icon_pause"
        *ngIf="
          getVideoElement(currentMediaIndex$.value)?.paused &&
          this.showPauseAnimations
        "
      ></span>
    </div>
    <div
      class="slider__media-controls__circles-container"
      *ngIf="(mediaArray?.length ?? 0) > 1"
    >
      <div
        *ngFor="let circle of mediaArray; let circleIndex = index"
        class="slider__media-controls__circle"
        (click)="currentMediaIndex$.next(circleIndex)"
        [class.slider__media-controls__circle_selected]="
          circleIndex === currentMediaIndex$.value
        "
      ></div>
    </div>
  </div>
</section>
